export const fitnessCopy = {
  "en-GB": {
    "navigation.activity": "Activity",
    "fitness.records": "Your activity records",
    "fitness.averageSteps": "Average steps / observed day",
    "fitness.activeDays": "Days with movement",
    "fitness.averageDistance": "Average walking distance / observed day",
    "fitness.averageCalories": "Average energy / observed day",
    "fitness.bestStepDay": "Best step day",
    "fitness.bestDistanceDay": "Longest walking day",
    "fitness.bestActiveDay": "Most active day",
    "fitness.peakGps": "Highest average speed",
    "fitness.averageNote": "Step average uses {days} days with estimates. Days without data are excluded. Other averages use days with the corresponding value.",
    "fitness.peakNote": "Speed is calculated between positions and may include transport.",
    "fitness.monthlyChart": "Estimated steps by month",
    "fitness.dailyChart": "Estimated steps by day",
    "fitness.stepsUnit": "estimated steps",
    "fitness.chartNote": "Select a bar for details. Grey means information is missing. Totals cover recorded trips only."
  },
  "da-DK": {
    "navigation.activity": "Aktivitet",
    "fitness.records": "Dine aktivitetsrekorder",
    "fitness.averageSteps": "Gennemsnitlige skridt / registreret dag",
    "fitness.activeDays": "Dage med bevægelse",
    "fitness.averageDistance": "Gennemsnitlig gangdistance / registreret dag",
    "fitness.averageCalories": "Gennemsnitlig energi / registreret dag",
    "fitness.bestStepDay": "Bedste skridtdag",
    "fitness.bestDistanceDay": "Længste gådag",
    "fitness.bestActiveDay": "Mest aktive dag",
    "fitness.peakGps": "Højeste gennemsnitsfart",
    "fitness.averageNote": "Skridtgennemsnittet bruger {days} dage med estimater. Dage uden data tæller ikke med. Andre gennemsnit bruger dage med den pågældende værdi.",
    "fitness.peakNote": "Farten er beregnet mellem positioner og kan også omfatte transport.",
    "fitness.monthlyChart": "Estimerede skridt pr. måned",
    "fitness.dailyChart": "Estimerede skridt pr. dag",
    "fitness.stepsUnit": "estimerede skridt",
    "fitness.chartNote": "Tryk på en søjle for at se flere detaljer. Grå betyder, at der mangler oplysninger. Tallene dækker kun registrerede ture."
  }
};
